document.addEventListener('DOMContentLoaded', function() {
  const imageContainers = document.querySelectorAll('[data-section-id]');

  imageContainers.forEach(function(imageContainer) {
    const sectionId = imageContainer.getAttribute('data-section-id');

    let imageLink = imageContainer.getAttribute('data-image-link');

    if (!imageLink) {
      const textContent = document.getElementById('ImageWithText--' + sectionId);
      if (textContent) {
        const buttons = textContent.querySelectorAll('a.button[href]:not([aria-disabled="true"])');

        if (buttons.length === 1) {
          const button = buttons[0];
          imageLink = button.getAttribute('href');
        }
      }
    }

    if (imageLink) {
      imageContainer.classList.add('image-with-text__media--clickable');

      imageContainer.addEventListener('click', function(e) {
        window.location.href = imageLink;
      });
    }
  });
});
